(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('appointment-type', {
                parent: 'entity',
                url: '/appointment-type',
                data: {
                    authorities: [],
                    pageTitle: 'AppointmentTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/appointment-type/appointment-types.html',
                        controller: 'AppointmentTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access);
                }]
            })
            .state('appointment-type.new', {
                parent: 'appointment-type',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/appointment-type/appointment-type-dialog.html',
                            controller: 'AppointmentTypeDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        facility: CoreService.getCurrentFacility()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('appointment-type', null, {reload: 'appointment-type'});
                        }, function () {
                            $state.go('appointment-type');
                        });
                    }
                }]
            })
            .state('appointment-type.edit', {
                parent: 'appointment-type',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/appointment-type/appointment-type-dialog.html',
                            controller: 'AppointmentTypeDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AppointmentType', function (AppointmentType) {
                                    return AppointmentType.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('appointment-type', null, {reload: 'appointment-type'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('appointment-type.delete', {
                parent: 'appointment-type',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/appointment-type/appointment-type-delete-dialog.html',
                            controller: 'AppointmentTypeDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AppointmentType', function (AppointmentType) {
                                    return AppointmentType.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('appointment-type', null, {reload: 'appointment-type'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();
